<template>
    <el-form :rules="validateRules">
        <div class="simple-form">
            <div class="form-group">
                <div class="form-label">
                    <label :class="requiredFlag ? 'required' : ''">预计到货日期</label>
                </div>
                <div class="form-value">
                    <el-date-picker class="width-1-5x" v-model="logisCom.expectArriveDate " :picker-options="pickerOptions0" type="date" placeholder="选择日期"></el-date-picker>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label ">
                    <label class="required">发货人</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="senderContactName">
                        <el-input class="width-1-5x" v-model="logisCom.senderContactName"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label ">
                    <label class="required">发货人联系方式</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="senderContactTel">
                        <el-input class="width-1-5x" v-model="logisCom.senderContactTel"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label :class="requiredFlag ? 'required' : ''">物流公司名称</label>
                </div>
                <div class="form-value">
                    <el-input class="width-1-5x bottom-line" disabled type="text" v-model="logisCom.logisComName"></el-input>
                    <div class="form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择" @click="selectLogisCom()"></div>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label :class="requiredFlag ? 'required' : ''">物流公司代码</label>
                </div>
                <div class="form-value">
                    <el-input class="width-1-5x bottom-line" disabled type="text" v-model="logisCom.logisComCode"></el-input>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label :class="requiredFlag ? 'required' : ''">物流单号</label>
                </div>
                <div class="form-value ">
                    <el-input class="width-1-5x" type="text" v-model="logisCom.logisExpNo"></el-input>
                </div>
            </div>
        </div>
    </el-form>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { openLogisComSelectDlg } from './showDlg'

    import merchtLogisApi from '../../api/merchtLogis'

    export default{
        name: 'swb-logis-com-set',
        desc: '物流信息设置',
        props: {
            requiredFlag: {
                type: Boolean,
                default: false
            },
            merchantId: {
                type: Number,
                default: null
            }
        },
        data: function () {
            let self = this;
            // 校验
            let validateSenderContactName = function (rule, value, callback) {
                let senderContactName = self.logisCom.senderContactName;
                if(Utils.isNoB(senderContactName)) {
                    callback(new Error('请输入发货人'));
                } else {
                    callback();
                }
            };
            let validateSenderContactTel = function (rule, value, callback) {
                let senderContactTel = self.logisCom.senderContactTel;
                if(!Utils.isNoB(senderContactTel)) {
                    if(!Utils.isPhoneNo(senderContactTel)) {
                        callback(new Error('请输入正确的发货人电话'));
                    } else {
                        callback();
                    }
                } else {
                    callback(new Error('请输入发货人电话'));
                }
            };
            return {
                logisCom: {},
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                // 校验
                validateRules: {
                    senderContactTel: [{validator: validateSenderContactTel, trigger: 'blur'}],
                    senderContactName: [{validator: validateSenderContactName, trigger: 'blur'}]
                },
            }
        },
        created: function () {

        },
        methods: {
            // 选择物流公司
            selectLogisCom: function () {
                let self = this;
                let logisCom = self.logisCom;
                let selectIds = [];
                if(!Utils.isNoB(logisCom) && logisCom.logisComId > 0) {
                    selectIds.push(logisCom.logisComId);
                }
                let params = {
                    merchantId: self.merchantId || null
                };
                openLogisComSelectDlg(false, selectIds, params, function (logisComInfo, theDlg) {
                    logisCom.logisComId = logisComInfo.logisComId;
                    logisCom.logisComName = logisComInfo.logisComName;
                    logisCom.logisComCode = logisComInfo.logisComCode;
                    self.logisCom = Utils.merge({}, logisCom);
                    theDlg.close();
                });
            },
            // 返回数据
            getDlgResult: function () {
                let self = this;
                let result = {};
                //
                let logisCom = self.logisCom || {};
                if(Utils.isTrue(self.requiredFlag)) {
                    if(Utils.isNoB(logisCom.expectArriveDate)) {
                        result.type = 'warn';
                        result.message = '请选择预计到货日期';
                    } else if(Utils.isNoB(logisCom.senderContactName)) {
                        result.type = 'warn';
                        result.message = '请输入发货人';
                    } else if(Utils.isNoB(logisCom.senderContactTel)) {
                        result.type = 'warn';
                        result.message = '请输入发货人联系方式';
                    } else if(Utils.isNoB(logisCom.logisComName) || Utils.isNoB(logisCom.logisComCode)) {
                        result.type = 'warn';
                        result.message = '请选择物流公司';
                    } else if(Utils.isNoB(logisCom.logisExpNo)) {
                        result.type = 'warn';
                        result.message = '请输入物流单号';
                    } else {
                        let reg = /^[0-9a-zA-Z]+$/;
                        let regx = /\d+/;
                        if(!reg.test(logisCom.logisExpNo) || !regx.test(logisCom.logisExpNo)) {
                            result.type = 'warn';
                            result.message = '物流单号只能是数字或字母和数字组成';
                        } else {
                            let resultData = {
                                expectArriveDate: logisCom.expectArriveDate,
                                logisComName: logisCom.logisComName,
                                logisComCode: logisCom.logisComCode,
                                logisExpNo: logisCom.logisExpNo,
                                senderContactName: logisCom.senderContactName,
                                senderContactTel: logisCom.senderContactTel
                            };
                            //
                            result.type = 'info';
                            result.data = resultData;
                        }
                    }
                } else {
                    if(Utils.isNoB(logisCom.senderContactName)) {
                        result.type = 'warn';
                        result.message = '请输入发货人';
                    } else if(Utils.isNoB(logisCom.senderContactTel)) {
                        result.type = 'warn';
                        result.message = '请输入发货人联系方式';
                    } else {
                        let reg = /^[0-9a-zA-Z]+$/;
                        let regx = /\d+/;
                        if(!Utils.isNoB(logisCom.logisExpNo)) {
                            if(Utils.isNoB(logisCom.logisComName)) {
                                result.type = 'warn';
                                result.message = '请选择物流公司';
                            } else {
                                if(!reg.test(logisCom.logisExpNo) || !regx.test(logisCom.logisExpNo)) {
                                    result.type = 'warn';
                                    result.message = '物流单号只能是数字或字母和数字组成';
                                } else {
                                    let resultData = {
                                        expectArriveDate: logisCom.expectArriveDate,
                                        logisComName: logisCom.logisComName,
                                        logisComCode: logisCom.logisComCode,
                                        logisExpNo: logisCom.logisExpNo,
                                        senderContactName: logisCom.senderContactName,
                                        senderContactTel: logisCom.senderContactTel
                                    };
                                    //
                                    result.type = 'info';
                                    result.data = resultData;
                                }
                            }
                        } else {
                            if(!Utils.isNoB(logisCom.logisComName)) {
                                if(Utils.isNoB(logisCom.logisExpNo)) {
                                    result.type = 'warn';
                                    result.message = '请输入物流单号';
                                } else {
                                    if(!reg.test(logisCom.logisExpNo) || !regx.test(logisCom.logisExpNo)) {
                                        result.type = 'warn';
                                        result.message = '物流单号只能是数字或字母和数字组成';
                                    } else {
                                        let resultData = {
                                            expectArriveDate: logisCom.expectArriveDate,
                                            logisComName: logisCom.logisComName,
                                            logisComCode: logisCom.logisComCode,
                                            logisExpNo: logisCom.logisExpNo,
                                            senderContactName: logisCom.senderContactName,
                                            senderContactTel: logisCom.senderContactTel
                                        };
                                        //
                                        result.type = 'info';
                                        result.data = resultData;
                                    }
                                }
                            } else {
                                let resultData = {
                                    expectArriveDate: logisCom.expectArriveDate,
                                    logisComName: logisCom.logisComName,
                                    logisComCode: logisCom.logisComCode,
                                    logisExpNo: logisCom.logisExpNo,
                                    senderContactName: logisCom.senderContactName,
                                    senderContactTel: logisCom.senderContactTel
                                };
                                //
                                result.type = 'info';
                                result.data = resultData;
                            }
                        }
                    }
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/merchtLogis/MerchtLogisComSet.vue